import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    product: [
      { label: 'Features', path: '/landing-page#features-section' },
      { label: 'Pricing', path: '/landing-page#pricing-section' },
      { label: 'Dashboard', path: '/dashboard' },
      { label: 'Business Canvas', path: '/business-model-canvas' }
    ],
    company: [
      { label: 'About Us', path: '/landing-page' },
      { label: 'Contact', path: '/landing-page' },
      { label: 'Careers', path: '/landing-page' },
      { label: 'Blog', path: '/landing-page' }
    ],
    resources: [
      { label: 'Documentation', path: '/landing-page' },
      { label: 'Help Center', path: '/landing-page' },
      { label: 'API Reference', path: '/landing-page' },
      { label: 'Community', path: '/landing-page' }
    ],
    legal: [
      { label: 'Privacy Policy', path: '/landing-page' },
      { label: 'Terms of Service', path: '/landing-page' },
      { label: 'Cookie Policy', path: '/landing-page' },
      { label: 'GDPR', path: '/landing-page' }
    ]
  };

  const socialLinks = [
    { icon: 'Twitter', label: 'Twitter', url: '#' },
    { icon: 'Linkedin', label: 'LinkedIn', url: '#' },
    { icon: 'Facebook', label: 'Facebook', url: '#' },
    { icon: 'Instagram', label: 'Instagram', url: '#' }
  ];

  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-8 md:py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 md:gap-12 mb-8 md:mb-12">
          <div className="lg:col-span-2">
            <Link to="/landing-page" className="flex items-center mb-4">
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/20">
                <Icon name="Zap" size={24} color="var(--color-primary)" />
              </div>
              <span className="ml-3 text-xl font-heading font-semibold text-foreground">
                Business Jadhak
              </span>
            </Link>
            <p className="text-sm text-muted-foreground font-body mb-4 max-w-sm">
              Root Your Strategy. Predict Your Growth. AI-powered decision intelligence platform for SMEs.
            </p>
            <div className="flex items-center gap-3">
              {socialLinks?.map((social) => (
                <a
                  key={social?.label}
                  href={social?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-md bg-muted flex items-center justify-center transition-smooth hover:bg-primary hover:text-primary-foreground"
                  aria-label={social?.label}
                >
                  <Icon name={social?.icon} size={18} color="currentColor" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-foreground mb-4">
              Product
            </h3>
            <ul className="space-y-3">
              {footerLinks?.product?.map((link) => (
                <li key={link?.label}>
                  <Link
                    to={link?.path}
                    className="text-sm text-muted-foreground font-body transition-smooth hover:text-primary"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-foreground mb-4">
              Company
            </h3>
            <ul className="space-y-3">
              {footerLinks?.company?.map((link) => (
                <li key={link?.label}>
                  <Link
                    to={link?.path}
                    className="text-sm text-muted-foreground font-body transition-smooth hover:text-primary"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-foreground mb-4">
              Resources
            </h3>
            <ul className="space-y-3">
              {footerLinks?.resources?.map((link) => (
                <li key={link?.label}>
                  <Link
                    to={link?.path}
                    className="text-sm text-muted-foreground font-body transition-smooth hover:text-primary"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-foreground mb-4">
              Legal
            </h3>
            <ul className="space-y-3">
              {footerLinks?.legal?.map((link) => (
                <li key={link?.label}>
                  <Link
                    to={link?.path}
                    className="text-sm text-muted-foreground font-body transition-smooth hover:text-primary"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-muted-foreground font-caption text-center md:text-left">
              &copy; {currentYear} Business Jadhak. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <Icon name="Shield" size={14} color="var(--color-success)" />
                <span className="text-xs text-muted-foreground font-caption">
                  SSL Secured
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Lock" size={14} color="var(--color-success)" />
                <span className="text-xs text-muted-foreground font-caption">
                  GDPR Compliant
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;